import { render, staticRenderFns } from "./NotificationDropDown.vue?vue&type=template&id=10afdb3c&scoped=true&"
import script from "./NotificationDropDown.vue?vue&type=script&lang=js&"
export * from "./NotificationDropDown.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDropDown.vue?vue&type=style&index=0&id=10afdb3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10afdb3c",
  null
  
)

export default component.exports